import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { getErrorLogIdFromResponse } from '../functions/ErrorLogging';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faHouse, faSpinner, faHouseCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useOutsideClick } from '../functions/OutsideClick';
import classNames from 'classnames';
import { faEnvelopeCircleCheck } from "@fortawesome/pro-light-svg-icons";
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons'
import { emailValidation, validFutureDate } from '../functions/Validation';
export default function Error(props: any) {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    props.setCurrentPage(0);
    props.setSidebarVisibility(false);
    const location = useLocation();
    let navigate = useNavigate();
    const [policyNumber, setPolicyNumber] = useState('');
    const [contactName, setContactName] = useState('');
    const [contactEmail, setContactEmail] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [changeType, setChangeType] = useState('');
    const [dayValue, setDayValue] = useState('');
    const [monthValue, setMonthValue] = useState('');
    const [yearValue, setYearValue] = useState('');
    const [address, setAddress] = useState({});
    const [postcode, setPostcode] = useState('');
    const [house, setHouse] = useState('');
    const [street, setStreet] = useState('');
    const [locality, setLocality] = useState('');
    const [city, setCity] = useState('');
    const [county, setCounty] = useState('');
    const [country, setCountry] = useState('');
    const [publicIndemnityLimit, setPublicIndemnityLimit] = useState('');
    const [numberOfDirectorsWorkingManually, setNumberOfDirectorsWorkingManually] = useState(0);
    const [numberOfNonDirectors, setNumberOfNonDirectors] = useState(0);
    const [numberOfEmployeesWorkingManually, setNumberOfEmployeesWorkingManually] = useState(0);
    const [numberOfNonManualEmployees, setNumberOfNonManualEmployees] = useState(0);
    const [annualTurnover, setAnnualTurnover] = useState(0);
    const [employeesTools, setEmployeesTools] = useState("False");
    const [toolsValue, setToolsValue] = useState('');
    const [otherChanges, setOtherChanges] = useState('');
    const [foundAddresses, setFoundAddresses] = useState<any[]>([]);
    const [searching, setSearching] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [requestSubmitted, setRequestSubmitted] = useState(false);
    const [validationFail, setValidationFail] = useState(false);

    var containerClasses = classNames(
        {
            'mta-container': true,
            'submitted': requestSubmitted
        }
    );

    useEffect(() => {
        window.scrollTo({
            top: 0
        });

        setPolicyNumber(localStorage.getItem("policyNumberMTA") || "");
        var defaultDate = new Date();
        defaultDate.setDate(defaultDate.getDate() + 1);

        if (defaultDate.getDate() < 10) {
            setDayValue("0" + defaultDate.getDate().toString());
        } else {
            setDayValue(defaultDate.getDate().toString());
        }

        if ((defaultDate.getMonth() + 1) < 10) {
            setMonthValue("0" + (defaultDate.getMonth() + 1).toString());
        } else {
            setMonthValue((defaultDate.getMonth() + 1).toString());
        }

        
        setYearValue(defaultDate.getFullYear().toString());
        let blankAddress: Address = {
            house: "",
            street: "",
            locality: "",
            city: "",
            county: "",
            country: "",
            postcode:""
        }

        setAddress(blankAddress);
    }, [])

    useEffect(() => {
        setValidationFail(false);
    }, [changeType])

    const handleClickOutside = () => {
        setNoResults(false);
        setFoundAddresses([]);
    };

    const ref = useOutsideClick(handleClickOutside);

    const searchPostcode = (postcode: string) => {
        setSearching(true);
        if (postcode !== "" && postcode !== null && postcode !== undefined) {
            fetch(`${apiBaseUrl}customer/searchpostcode/${postcode}`)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    setSearching(false);
                    if (data.object !== "") {
                        let foundAddresses = JSON.parse(data.object);
                        setFoundAddresses(foundAddresses);
                    } else {
                        setNoResults(true);
                    }
                }).catch((error) => {
                    let errorLogId = getErrorLogIdFromResponse(error);
                    localStorage.setItem("errorLogId", errorLogId);
                    navigate('/Error');
                    setSearching(false);
                    setNoResults(true);
                });
        } else {
            setSearching(false);
            setNoResults(true);
        }
    }

    const selectAddress = (index: number) => {
        let selectedAddress = foundAddresses[index];
        delete selectedAddress.extensionData;
        setAddress(selectedAddress);
        setHouse(selectedAddress.house);
        setStreet(selectedAddress.street);
        setLocality(selectedAddress.locality);
        setCity(selectedAddress.city);
        if (typeof selectedAddress.county == "string") {
            setCounty(selectedAddress.county);
        }
        setCountry("United Kingdom");
        setFoundAddresses([]);
    }

    const SubmitMTA = () => {

        let validationFailed = validateForm();

        setValidationFail(validationFailed);

        if (!validationFailed) {

            let effectiveDate = `${yearValue}-${monthValue}-${dayValue}T00:00:00.784Z`;

            let requestObject: MTA = {
                policyNumber: policyNumber,
                contactName: contactName,
                contactEmail: contactEmail,
                contactNumber: contactNumber,
                changeType: changeType,
                effectiveDate: effectiveDate,
                address: {
                    house: house,
                    street: street,
                    locality: locality,
                    city: city,
                    county: county,
                    country: country,
                    postcode: postcode
                },
                publicIndemnityLimit: publicIndemnityLimit,
                numberOfDirectorsWorkingManually: numberOfDirectorsWorkingManually,
                numberOfNonDirectors: numberOfNonDirectors,
                numberOfEmployeesWorkingManually: numberOfEmployeesWorkingManually,
                numberOfNonManualEmployees: numberOfNonManualEmployees,
                annualTurnover: annualTurnover,
                employeesTools: employeesTools === "True",
                toolsValue: toolsValue,
                otherChanges: otherChanges
            };

            fetch(`${apiBaseUrl}admin/MTA`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain',
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                body: JSON.stringify(requestObject)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    if (data.success) {
                        setRequestSubmitted(true);
                    } else {

                    }
                }).catch((error) => {

                });
        }
    }

    


    const validateForm = () => {
        if (contactName === "" || contactEmail === "" || contactNumber === "" || changeType === "" || !validFutureDate(dayValue, monthValue, yearValue) || !emailValidation(contactEmail)) {
            return true;
        }

        if (changeType === "Change of address" &&
            (postcode === "" || house === "" || street === "" || locality === "" || city === "" || county === "" || country === "")) {
            return true;
        }

        if (changeType === "Public limit of indemnity" && publicIndemnityLimit === "") {
            return true;
        }

        if (changeType === "Change number of employees" && (isNaN(numberOfDirectorsWorkingManually) || isNaN(numberOfNonDirectors) || isNaN(numberOfEmployeesWorkingManually) || isNaN(numberOfNonManualEmployees))) {
            return true;
        }

        if (changeType === "Change turnover" && isNaN(annualTurnover)) {
            return true;
        }

        if (changeType === "Add tools cover" && toolsValue === "") {
            return true;
        }

        if (changeType === "Multiple/other changes" && otherChanges === "") {
            return true;
        }

        return false;
    }

    return (
        <>
        
        <div className={containerClasses} onClick={() => setFoundAddresses([])}>
            {!requestSubmitted && <>
                <div className="mta-header"><h1>Make changes to your policy</h1></div> 
                <label>Policy Number</label>
                <input type="text" value={policyNumber} disabled></input>

                <label>Contact Name</label>
                    <input type="text" value={contactName} onChange={(e) => setContactName(e.target.value)} className={(validationFail && contactName === "") ? "validation-fail" : ""}></input>
                {validationFail && contactName === "" && 
                    <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> This field can't be empty</div>
                }

                <label>Contact Email</label>
                    <input type="text" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} className={(validationFail && !emailValidation(contactEmail)) ? "validation-fail" : ""}></input>
                    {validationFail && !emailValidation(contactEmail) && 
                    <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please enter a valid email address</div>
                }

                <label>Contact Number</label>
                    <input type="text" value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} className={(validationFail && contactNumber === "") ? "validation-fail" : ""}></input>
                {validationFail && contactNumber === "" && 
                    <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please enter a valid contact number</div>
                }


                    <label>What would you like to change</label>
                    <select value={changeType} onChange={(e) => setChangeType(e.target.value)} className={(validationFail && changeType === "") ? "validation-fail" : ""}>
                    <option value="">- Please select a type of change -</option>
                    <option value="Change of address">Change of address</option>
                    <option value="Public limit of indemnity">Public limit of indemnity</option>
                    <option value="Change number of employees">Change number of employees</option>
                    <option value="Change turnover">Change turnover</option>
                    <option value="Add tools cover">Add tools cover</option>
                    <option value="Multiple/other changes">Multiple/other changes</option>
                </select>
                {validationFail && changeType === "" && 
                    <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please select an option</div>
                }

                <label>Effective Date</label>
                <div className="date-text-container">
                    <input
                        type="text"
                        value={dayValue}
                        onChange={(e) => setDayValue(e.target.value)}
                        placeholder="DD"
                        maxLength={2}
                        className={(validationFail && !validFutureDate(dayValue, monthValue, yearValue)) ? "date-text validation-fail" : "date-text"}
                    />
                    <span> - </span>
                    <input
                        type="text"
                        value={monthValue}
                        onChange={(e) => setMonthValue(e.target.value)}
                        placeholder="MM"
                        maxLength={2}
                        className={(validationFail && !validFutureDate(dayValue, monthValue, yearValue)) ? "date-text validation-fail" : "date-text"}
                    />
                    <span> - </span>
                    <input
                        type="text"
                        value={yearValue}
                        onChange={(e) => setYearValue(e.target.value)}
                        placeholder="YYYY"
                        maxLength={4}
                        className={(validationFail && !validFutureDate(dayValue, monthValue, yearValue)) ? "date-text validation-fail" : "date-text"}
                    />
                    {validationFail && !validFutureDate(dayValue, monthValue, yearValue) && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please enter a valid future date</div>
                    }
                </div>

                {changeType === "Change of address" &&
                    <>
                    <label>Postcode</label>
                    <div className="search-container">
                        <div className="search-inner">
                            <input
                                type="text"
                                value={postcode}
                                className={(validationFail && postcode === "") ? "mta-postcode-search validation-fail" : "mta-postcode-search"}
                                onChange={(e) => setPostcode(e.target.value)}
                                onKeyUp={(event) => {
                                    if (event.key === "Enter") {
                                        searchPostcode(postcode);
                                    }
                                }}
                            />
                            {!searching && <button className="btn-address icon" onClick={() => searchPostcode(postcode)}><FontAwesomeIcon icon={faMagnifyingGlass} /></button>}
                            {searching && <button className="btn-address icon searching"><FontAwesomeIcon icon={faSpinner} spinPulse /></button>}
                        </div>
                        <div className="dropdown">
                            {noResults && <div ref={ref} className="dropdown-row no-results"><FontAwesomeIcon className="error-icon" icon={faHouseCircleExclamation} /> No addresses found</div>}
                            {foundAddresses.map((address, index) => (
                                <div className="dropdown-row" key={index} onClick={() => selectAddress(index)}>{address.house + ", " + address.street + ", " + address.locality + ", " + address.city + ", " + address.postcode}</div>
                            ))}
                        </div>
                    </div>
                    {validationFail && postcode === "" && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> This field can't be empty</div>
                    }

                    <label>House</label>
                    <input type="text" value={house} onChange={(e) => setHouse(e.target.value)} className={(validationFail && house === "") ? "validation-fail" : ""}></input>
                    {validationFail && house === "" && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> This field can't be empty</div>
                    }

                    <label>Street</label>
                    <input type="text" value={street} onChange={(e) => setStreet(e.target.value)} className={(validationFail && street === "") ? "validation-fail" : ""}></input>
                    {validationFail && street === "" && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> This field can't be empty</div>
                    }

                    <label>Locality</label>
                    <input type="text" value={locality} onChange={(e) => setLocality(e.target.value)} className={(validationFail && locality === "") ? "validation-fail" : ""}></input>
                    {validationFail && locality === "" && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> This field can't be empty</div>
                    }

                    <label>City</label>
                    <input type="text" value={city} onChange={(e) => setCity(e.target.value)} className={(validationFail && city === "") ? "validation-fail" : ""}></input>
                    {validationFail && city === "" && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> This field can't be empty</div>
                    }

                    <label>County</label>
                    <input type="text" value={county} onChange={(e) => setCounty(e.target.value)} className={(validationFail && county === "") ? "validation-fail" : ""}></input>
                    {validationFail && county === "" && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> This field can't be empty</div>
                    }

                    <label>Country</label>
                    <input type="text" value={country} onChange={(e) => setCountry(e.target.value)} className={(validationFail && country === "") ? "validation-fail" : ""}></input>
                    {validationFail && country === "" && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> This field can't be empty</div>
                    }
                    </>
                }

                {changeType === "Public limit of indemnity" &&
                <>
                    <label>Please select the Public Limit of Indemnity you require</label>
                    <select value={publicIndemnityLimit} onChange={(e) => setPublicIndemnityLimit(e.target.value)} className={(validationFail && publicIndemnityLimit === "") ? "validation-fail" : ""}>
                        <option value=""></option>
                        <option value="&pound;1,000,000.00">&pound;1,000,000.00</option>
                        <option value="&pound;2,000,000.00">&pound;2,000,000.00</option>
                        <option value="&pound;5,000,000.00">&pound;5,000,000.00</option>
                        <option value="&pound;10,000,000.00">&pound;10,000,000.00</option>
                    </select>
                    {validationFail && publicIndemnityLimit === "" && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please select an option</div>
                    }
                </>
                }

                {changeType === "Change number of employees" &&
                    <>
                    <label>Total number of directors working manually</label>
                    <input type="number" value={numberOfDirectorsWorkingManually} onChange={(e) => setNumberOfDirectorsWorkingManually(parseInt(e.target.value))} className={(validationFail && isNaN(numberOfDirectorsWorkingManually)) ? "validation-fail" : ""}></input>
                    {validationFail && isNaN(numberOfDirectorsWorkingManually) && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please enter a valid number</div>
                    }

                    <label>Total number of non-directors</label>
                    <input type="number" value={numberOfNonDirectors} onChange={(e) => setNumberOfNonDirectors(parseInt(e.target.value))} className={(validationFail && isNaN(numberOfNonDirectors)) ? "validation-fail" : ""}></input>
                    {validationFail && isNaN(numberOfNonDirectors) && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please enter a valid number</div>
                    }

                    <label>Total number of employees working manually including labour only contractors</label>
                    <input type="number" value={numberOfEmployeesWorkingManually} onChange={(e) => setNumberOfEmployeesWorkingManually(parseInt(e.target.value))} className={(validationFail && isNaN(numberOfEmployeesWorkingManually)) ? "validation-fail" : ""}></input>
                    {validationFail && isNaN(numberOfEmployeesWorkingManually) && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please enter a valid number</div>
                    }

                    <label>Total number of non-manual employees</label>
                    <input type="number" value={numberOfNonManualEmployees} onChange={(e) => setNumberOfNonManualEmployees(parseInt(e.target.value))} className={(validationFail && isNaN(numberOfNonManualEmployees)) ? "validation-fail" : ""}></input>
                    {validationFail && isNaN(numberOfNonManualEmployees) && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please enter a valid number</div>
                    }

                    </>
                }

                {changeType === "Change turnover" &&
                    <>
                    <label>What is your new annual turnover</label>
                    <input type="number" value={annualTurnover} onChange={(e) => setAnnualTurnover(parseInt(e.target.value))} className={(validationFail && isNaN(annualTurnover)) ? "validation-fail" : ""}></input>
                    {validationFail && isNaN(annualTurnover) && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please enter a valid number</div>
                    }
                    </>
                }

                {changeType === "Add tools cover" &&
                    <>
                    <label>Do you want cover for your employee's tools</label>
                    <select value={employeesTools} onChange={(e) => setEmployeesTools(e.target.value)}>
                        <option value="True">Yes</option>
                        <option value="False">No</option>
                    </select>

                    <label>What value of tools cover would you like</label>
                    <select value={toolsValue} onChange={(e) => setToolsValue(e.target.value)} className={(validationFail && toolsValue === "") ? "validation-fail" : ""}>
                        <option value=""></option>
                        <option value="&pound;500">&pound;500</option>
                        <option value="&pound;1,000">&pound;1,000</option>
                        <option value="&pound;1,250">&pound;1,250</option>
                        <option value="&pound;1,500">&pound;1,500</option>
                        <option value="&pound;2,500">&pound;2,500</option>
                        <option value="&pound;5,000">&pound;5,000</option>
                        <option value="&pound;7,500">&pound;7,500</option>
                        <option value="&pound;10,000">&pound;10,000</option>
                        <option value="&pound;12,500">&pound;12,500</option>
                        <option value="&pound;25,000">&pound;25,000</option>
                    </select>
                    {validationFail && toolsValue === "" && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> Please select an option</div>
                    }
                    </>
                }

                {changeType === "Multiple/other changes" &&
                    <>
                    <label>Please detail all changes below</label>
                    <textarea value={otherChanges} onChange={(e) => setOtherChanges(e.target.value)} className={(validationFail && otherChanges === "") ? "text-area validation-fail" : "text-area"}></textarea>
                    {validationFail && otherChanges === "" && 
                        <div className="validation-message"><FontAwesomeIcon icon={faCircleExclamation} /> This field can't be empty</div>
                    }
                    </>
                }
                <br />
                <div className="btn-container">
                    <button className="btn back" onClick={() => navigate("/YourAccount")}>Back: Your Account</button>
                    <button className="btn primary" onClick={() => SubmitMTA()}>Submit changes</button>
                </div>
            </>}
                {requestSubmitted && <>
                <FontAwesomeIcon className="alert-icon" icon={faEnvelopeCircleCheck} />
                <div className="mta-header"><h1>Make changes to your policy</h1></div> 
                <p>Thank you for submitting your details. One of our agents will be in touch within the next 48 hours. Please note that the change will not take effect until we have confirmed this via phone or email.</p>
                <button className="btn back" onClick={() => navigate("/YourAccount")}>Back: Your Account</button>
            </>}
            </div>
        </>
    );
};